function getMicrositeState(state) {
  return {
    isLoading: state.microsite.myMicrosite.loading,
    error: state.microsite.myMicrosite.error,
    success: state.microsite.myMicrosite.success,
    errorUpload: state.microsite.myMicrosite.errorUpload,
    errorDelete: state.microsite.myMicrosite.errorDelete,
    errorSave: state.microsite.myMicrosite.errorSave,
    data: state.microsite.myMicrosite.data,
    isUploading: state.microsite.myMicrosite.isUploading,
    coverPhoto: state.microsite.myMicrosite.coverPhoto,
    fetched: state.microsite.myMicrosite.fetched,
    listPhone: state.microsite.myMicrosite.listPhone
  };
}

export { getMicrositeState };
